import { useAuth } from '../auth/AuthContext'
import { Button } from '../components/Button'

export function AccountPage() {
  const { user, memberships, signOut } = useAuth()

  return (
    <div className="flex flex-col gap-8">
      <header className="flex flex-col gap-3">
        <h1 className="font-display text-display-l text-ink">Account</h1>
        <p className="max-w-prose text-body-l text-ink-muted">
          Your profile, organization memberships and session security.
        </p>
      </header>

      <section aria-labelledby="profile-heading" className="flex flex-col gap-4">
        <h2 id="profile-heading" className="font-display text-display-m text-ink">
          Profile
        </h2>
        <dl className="grid grid-cols-1 gap-x-8 gap-y-4 rounded-2xl border border-line bg-ground-2 p-6 sm:grid-cols-2">
          <div>
            <dt className="text-small text-ink-muted">Email</dt>
            <dd className="text-body text-ink">{user?.email ?? '—'}</dd>
          </div>
          <div>
            <dt className="text-small text-ink-muted">User ID</dt>
            <dd className="break-all font-mono text-small text-ink">{user?.id ?? '—'}</dd>
          </div>
        </dl>
      </section>

      <section aria-labelledby="org-heading" className="flex flex-col gap-4">
        <h2 id="org-heading" className="font-display text-display-m text-ink">
          Organizations
        </h2>
        <ul className="flex flex-col gap-3">
          {memberships.map((membership) => (
            <li
              key={membership.id}
              className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-line bg-ground-2 px-6 py-4"
            >
              <div>
                <p className="text-body font-medium text-ink">
                  {membership.organizations?.name ?? 'Unknown organization'}
                </p>
                <p className="text-small text-ink-muted">
                  {membership.organizations?.slug} · {membership.organizations?.kind}
                </p>
              </div>
              <span className="rounded-full border border-line bg-ground-3 px-3 py-1 text-small capitalize text-ink-muted">
                {membership.role}
              </span>
            </li>
          ))}
        </ul>
      </section>

      <section aria-labelledby="security-heading" className="flex flex-col gap-4">
        <h2 id="security-heading" className="font-display text-display-m text-ink">
          Session security
        </h2>
        <div className="rounded-2xl border border-line bg-ground-2 p-6">
          <p className="text-body text-ink-muted">
            In Phase 1 your session tokens are kept in memory only and never stored in
            localStorage/sessionStorage — a successful XSS cannot exfiltrate them. The trade-off: a
            full page reload signs you out. Phase 2 moves sessions into httpOnly cookies issued by an
            auth Worker.
          </p>
        </div>
        <div>
          <Button variant="danger" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </section>
    </div>
  )
}
